import styled, { css } from 'styled-components';
import { BodySmReg } from '@seed-health/tokens';
import { mqSmallMin } from 'styled/tools/media-queries';
import TextButton from 'components/global/Button/Text';

interface StyledBannerProps {
  $dark?: boolean;
}

const bannerShell = css<StyledBannerProps>`
  width: 100%;
  min-height: 40px;
  // Phones give up side padding so promo copy and its action stay on one line.
  padding: var(--spacing-8) var(--spacing-16);
  gap: var(--spacing-4);
  text-align: center;
  background-color: ${({ $dark }) =>
    $dark ? 'var(--fill-brand)' : 'var(--guidance-primary)'};
  color: ${({ $dark }) =>
    $dark ? 'var(--text-inverse-primary)' : 'var(--text-primary)'};

  @media ${mqSmallMin} {
    padding: var(--spacing-8) var(--spacing-56);
  }
`;

const interactiveLabel = css`
  && * {
    color: inherit;
  }

  &&:hover {
    opacity: 1;
  }

  && > span:first-child {
    border-top: var(--stroke-active) solid transparent;
    border-bottom-color: transparent;
  }

  &&:hover > span:first-child {
    border-bottom-color: currentColor;
  }
`;

export const Message = styled.span`
  ${BodySmReg}
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-4);
  color: inherit;

  svg {
    flex-shrink: 0;
    fill: currentColor;
    stroke: currentColor;
    color: currentColor;
  }
`;

export const BannerContainer = styled.div<StyledBannerProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  ${bannerShell}
`;

export const Action = styled(TextButton)`
  && {
    height: auto;
    padding: 0;
    color: inherit;
  }

  ${interactiveLabel}

  &::after {
    content: '';
    position: absolute;
    inset: 0;
  }
`;

// if the banner acts as a button, style a global TextButton
export const BannerButton = styled(TextButton)<StyledBannerProps>`
  && {
    ${bannerShell}
    ${BodySmReg}
    height: auto;
  }

  ${interactiveLabel}
`;
